import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class SaveContactTokenUserService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {SaveContactTokenUserErrorFactory} deps.saveContactTokenUserErrorFactory
   * @param {UserRepository} deps.userRepository
   */
  constructor({saveContactTokenUserErrorFactory, userRepository}) {
    super()

    this._userRepository = userRepository
    this._saveContactTokenUserErrorFactory = saveContactTokenUserErrorFactory
  }

  /**
   * @return {Promise<Empty, Error>} returns empty promise
   */
  @inlineError
  async execute({contactTokenValueObject}) {
    const [error] = this._userRepository.saveContactToken({
      contactTokenValueObject
    })

    if (error) {
      throw this._saveContactTokenUserErrorFactory()
    }

    return Promise.resolve()
  }
}
